/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

import { core } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import BasicDropdown from '@tock/shared/components/inputs/basic-dropdown/BasicDropdown';
import CreditCardDropdownOption from 'components/business/checkout/CreditCardDropdownOption';

interface Props {
  labelId?: string;
  cards: core.PaymentCard[];
  disabled: boolean;
  selectedCard?: core.PaymentCard;
  onSelectCard(newPaymentCard: { value: string }): void;
}

export default class CreditCardDropdown extends BaseComponent<Props> {
  static defaultProps = {
    disabled: false,
  };

  render() {
    const { cards, disabled, selectedCard, onSelectCard, labelId } = this.props;

    let options = _.map(cards as any[], (card) => ({
      brand: card.brand,
      key: card.storedToken,
      label: `(${card.brand}) ... ${card.maskedNumber}`,
      maskedNumber: card.maskedNumber,
      value: card.storedToken,
    }));

    options = _.uniqBy(_.filter(options), 'value');

    options.unshift({
      brand: null,
      key: 'add-card',
      label: 'Add a payment method',
      maskedNumber: null,
      value: null,
    });

    let selectedOption: any = options[0];

    if (selectedCard) {
      selectedOption = _.find(options, (o) => o.value === selectedCard.storedToken);
    }

    return (
      <BasicDropdown
        labelId={labelId}
        contextClassName="FSHide"
        component={CreditCardDropdownOption}
        disabled={disabled}
        options={options}
        selectedOption={selectedOption}
        onSelect={onSelectCard}
      />
    );
  }
}
